import { collection, getDocs, doc, getDoc, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import { getAuth } from 'firebase/auth';

const INTERNAL_USERS_COLLECTION = 'internal_users';

const devLog = (...args) => {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
};

export const getInternalUsers = async () => {
  try {
    devLog('Fetching internal users from internal_users collection...');
    const usersRef = collection(db, INTERNAL_USERS_COLLECTION);
    const querySnapshot = await getDocs(usersRef);
    
    const formattedUsers = querySnapshot.docs.map(doc => {
      const data = doc.data();
      const user = {
        id: doc.id,
        ...data,
        type: 'internal',
        name: `${data.firstName || ''} ${data.lastName || ''}`.trim(),
        initials: `${data.firstName?.[0] || ''}${data.lastName?.[0] || ''}`
      };
      devLog('Formatted user:', user.id, user.name);
      return user;
    });
    
    devLog('All formatted internal users:', formattedUsers.length);
    
    // If no users found in internal_users collection, try the users collection with isInternal flag
    if (formattedUsers.length === 0) {
      devLog('No users found in internal_users collection, trying users collection...');
      const usersCollectionRef = collection(db, 'users');
      const internalUsersQuery = query(usersCollectionRef, where('isInternal', '==', true));
      const internalUsersSnapshot = await getDocs(internalUsersQuery);
      
      const fallbackUsers = internalUsersSnapshot.docs.map(doc => {
        const data = doc.data();
        return {
          id: doc.id,
          ...data,
          type: 'internal',
          name: `${data.firstName || data.displayName || ''} ${data.lastName || ''}`.trim(),
          initials: `${data.firstName?.[0] || data.displayName?.[0] || ''}${data.lastName?.[0] || ''}`
        };
      });
      
      devLog('Fallback internal users:', fallbackUsers.length);
      return fallbackUsers;
    }
    
    return formattedUsers;
  } catch (error) {
    console.error('Error getting internal users:', error);
    throw error;
  }
};

export const getInternalUserById = async (userId) => {
  try {
    const userRef = doc(db, INTERNAL_USERS_COLLECTION, userId);
    const userDoc = await getDoc(userRef);
    
    if (userDoc.exists()) {
      const data = userDoc.data();
      return {
        id: userDoc.id,
        ...data,
        type: 'internal',
        initials: `${data.firstName?.[0] || ''}${data.lastName?.[0] || ''}`
      };
    } else {
      throw new Error('User not found');
    }
  } catch (error) {
    console.error('Error getting internal user:', error);
    throw error;
  }
}; 